import * as types from '../actions/types';

const initialState = {
    page:1,
    success: false
}

export default function BannerListPageReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.BANNER_LIST_PAGE:
            return {
                ...state,
                page: action.payload,
                success: true
            }
        default:
            return state
    }
}